'use client';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, Fragment } from 'react';
import { useShoppingCart } from '@/context/ShoppingCartContext';

import { useSpinnerContext } from '@/context/SpinnerContext';

import { useTranslation } from 'react-i18next';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import customToaster from '@/components/toast/CustomToaster';
export function AddMultiProductDialog({ addToCartCallback }: { addToCartCallback: Function }) {
  const { mergeOverlapPrimaryItemRef, multiProductCartItemRef } = useShoppingCart();
  const { startLoaderEvent, stopLoaderEvent } = useSpinnerContext();
  const { t } = useTranslation('orderImagery');
  const [open, setOpen] = useState(false);

  const handleClickOpen = async () => {
    if (multiProductCartItemRef.current?.overlapData?.length === 1) {
      customToaster(`${t('minImageError', 'Please add at least 2 images')}`);

      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    // setOpenMultiProductDialog(false);
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        size="large"
        startIcon={<ShoppingCartOutlinedIcon />}
        variant="contained"
        onClick={() => {
          handleClickOpen();
        }}
        aria-label="mp-add-to-cart"
        name="Add to cart"
        disabled={!mergeOverlapPrimaryItemRef.current}
      >
        Add to Cart
      </Button>

      {/* Dialog 1 is the option to choose if you want overlapping images seperately or not      PaperProps={{
          sx: {
            maxWidth: '600px !important',
          },
        }} */}
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        className="skywatch-dialog multiple-cart-dialogue overlapping-dialog multi-drop-wrap"
      >
        <DialogTitle>{t('moTitle1')}</DialogTitle>
        <IconButton
          aria-label="close"
          className="close-btn"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 26,
            top: 12,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* This is multi product starting */}
        <DialogContent>
          <Typography variant="body1">{t('moTitle5')}</Typography>
          {/* <Typography variant="body1">How would you like to proceed?</Typography> */}

          <Stack
            justifyContent="space-between"
            gap={3}
            direction="row"
            className="multi-cart-btn-wrap"
          >
            <Button
              name="continue-button"
              size="large"
              onClick={() => {
                handleClose();
              }}
              fullWidth
              variant="outlined"
              color="primary"
            >
              {t('searchResultsBack', 'Back to search results')}
            </Button>
            <Button
              name="continue-button"
              size="large"
              onClick={() => {
                addToCartCallback();
                handleClose();
              }}
              fullWidth
              variant="contained"
              color="primary"
              aria-label="mp-done-add-to-cart"
            >
              {t('addToCart', 'Add to cart')}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
